/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Origin } from './';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
} from './';

/**
 * 
 * @export
 * @interface RefinementCriteriaWithOrigin
 */
export interface RefinementCriteriaWithOrigin {
    /**
     * 
     * @type {string}
     * @memberof RefinementCriteriaWithOrigin
     */
    criterion: string;
    /**
     * 
     * @type {Origin}
     * @memberof RefinementCriteriaWithOrigin
     */
    origin: Origin;
}

/**
 * Check if a given object implements the RefinementCriteriaWithOrigin interface.
 */
export function instanceOfRefinementCriteriaWithOrigin(value: object): value is RefinementCriteriaWithOrigin {
    if (!('criterion' in value) || value['criterion'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function RefinementCriteriaWithOriginFromJSON(json: any): RefinementCriteriaWithOrigin {
    return RefinementCriteriaWithOriginFromJSONTyped(json, false);
}

export function RefinementCriteriaWithOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefinementCriteriaWithOrigin {
    if (json == null) {
        return json;
    }
    return {
        
        'criterion': json['criterion'],
        'origin': OriginFromJSON(json['origin']),
    };
}

export function RefinementCriteriaWithOriginToJSON(value?: RefinementCriteriaWithOrigin | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'criterion': value['criterion'],
        'origin': OriginToJSON(value['origin']),
    };
}

